import formatTitle from './format-title';

export { formatTitle };

export default formatTitle;
